"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _find = _interopRequireDefault(require("lodash/find"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _channelEventEmitter = _interopRequireDefault(require("./channel-event-emitter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TriggerOnceEvents = /*#__PURE__*/function () {
  function TriggerOnceEvents() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$channel = _ref.channel,
        channel = _ref$channel === void 0 ? 'default' : _ref$channel,
        _ref$triggerOnceEvent = _ref.triggerOnceEvents,
        triggerOnceEvents = _ref$triggerOnceEvent === void 0 ? [] : _ref$triggerOnceEvent;

    _classCallCheck(this, TriggerOnceEvents);

    this.emitter = new _channelEventEmitter["default"](channel);
    this.triggerOnceEvents = triggerOnceEvents;
    this.previouslyTriggered = [];
  }

  _createClass(TriggerOnceEvents, [{
    key: "getPreviouslyTriggeredEvent",
    value: function getPreviouslyTriggeredEvent(event) {
      return (0, _find["default"])(this.previouslyTriggered, {
        event: event
      });
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      var previous = this.getPreviouslyTriggeredEvent(event);
      this.emitter.on(event, callback); // Immediately trigger if it is triggerOnce and has been triggered already

      if (previous && (0, _includes["default"])(this.triggerOnceEvents, event)) {
        try {
          callback(previous.data);
        } catch (error) {
          // TODO: Rely on @flowio/logger
          console.log("[ERROR] Failed to execute callback function for subscribed event[".concat(event, "] due to error[").concat(error.message, "] in provided callback function"), error);
          this.emitter.trigger('error', new Error("Failed to execute callback function for subscribed event[".concat(event, "] due to error[").concat(error.message, "] in provided callback function")));
        }
      }
    }
  }, {
    key: "onError",
    value: function onError(callback) {
      this.emitter.on('error', callback);
    }
    /**
     * Trigger an event. Check if the event is configured to only be triggered once
     * per page view. If so, don't actually trigger event. Any new callbacks
     * registered to triggerOnce events will be triggered automatically if it has
     * been triggered already.
     *
     * @param  {string} event  Event key.
     * @param  {Mixed} data The data to send when triggering event
     */

  }, {
    key: "trigger",
    value: function trigger(event, data) {
      var previous = this.getPreviouslyTriggeredEvent(event);

      if (previous && (0, _includes["default"])(this.triggerOnceEvents, event)) {
        // TODO: Rely on @flowio/logger
        console.log("[WARNING] Event [".concat(event, "] was already triggered. It is configured to only be triggered once per page view."));
        return;
      }

      try {
        this.emitter.trigger(event, data);
        this.previouslyTriggered.push({
          event: event,
          data: data
        });
      } catch (error) {
        // TODO: Rely on @flowio/logger
        console.log("[ERROR] Failed to execute all callbacks for triggered event[".concat(event, "] due to error[").concat(error.message, "] in provided callback function"), error);
        this.emitter.trigger('error', new Error("Failed to execute all callbacks for triggered event[".concat(event, "] due to error[").concat(error.message, "] in provided callback function")));
      }
    }
    /**
     * Reset previously triggered events. If no eventsToReset are provided, all events previously
     * triggered will be forgotten.
     *
     * @param {String[]} eventsToReset - Events to be reset
     */

  }, {
    key: "resetPreviouslyTriggered",
    value: function resetPreviouslyTriggered() {
      var eventsToReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (eventsToReset.length) {
        this.previouslyTriggered = (0, _filter["default"])(this.previouslyTriggered, function (previous) {
          return !(0, _includes["default"])(eventsToReset, previous.event);
        });
      } else {
        this.previouslyTriggered = [];
      }
    }
  }]);

  return TriggerOnceEvents;
}();

exports["default"] = TriggerOnceEvents;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/events/lib/trigger-once-events.js
// module id = 548
// module chunks = 0 1